module.exports = __webpack_public_path__ + "img/approved.eb42cc6c.svg";